// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MapBuilding__mapBuildingBody___g93fG {
    display: flex;
    height: 58.2rem;
}

.MapBuilding__mapBuildingFooter___eaXrW {
    justify-content: flex-end;
}

.MapBuilding__bodyDisabled___Tf_X6 {
    pointer-events: none;
    color: white;
    opacity: 0.5;
}

.MapBuilding__mapBuildingRight___MPTjW {
    padding: 0;
}
`, "",{"version":3,"sources":["webpack://./src/core/modules/Modals/MapBuilding/MapBuilding.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,UAAU;AACd","sourcesContent":[".mapBuildingBody {\n    display: flex;\n    height: 58.2rem;\n}\n\n.mapBuildingFooter {\n    justify-content: flex-end;\n}\n\n.bodyDisabled {\n    pointer-events: none;\n    color: white;\n    opacity: 0.5;\n}\n\n.mapBuildingRight {\n    padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mapBuildingBody": `MapBuilding__mapBuildingBody___g93fG`,
	"mapBuildingFooter": `MapBuilding__mapBuildingFooter___eaXrW`,
	"bodyDisabled": `MapBuilding__bodyDisabled___Tf_X6`,
	"mapBuildingRight": `MapBuilding__mapBuildingRight___MPTjW`
};
export default ___CSS_LOADER_EXPORT___;
